/*
* 菜单栏logo组件
*/

import { Space, theme, Typography } from 'antd';
import CNF from '../incs/Config';
import { XinYuanIcon } from '../incs/Icons';


const { Title } = Typography;
const YMenuLogo = () => {
    const {
        token: {
            colorPrimary,
        },
    } = theme.useToken();

    return (
        <div style={{ display: 'flex', height: `${CNF.menuHeight}px`, alignItems: 'center', }}>
            <Space>
                <XinYuanIcon style={{ fontSize: 25, color: colorPrimary, }} />
                <Title style={{ marginTop: 9, color: colorPrimary, }} level={5}>{CNF.projectShortName}</Title>
            </Space>
        </div>
    );
}
export default YMenuLogo;